import React, { memo } from 'react';
import { Instagram, Facebook, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-cream-100 pt-20 pb-10 border-t border-white/10" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-122">
          {/* Column 1: Brand */}
          <div className="lg:col-span-1" data-id="element-123">
            <a href="#" className="inline-block mb-6" data-id="element-124">
              <span className="font-playfair text-2xl font-bold tracking-tight text-white" data-id="element-125">
                Wine & Design
              </span>
            </a>
            <p className="text-cream-100/70 text-sm leading-relaxed mb-6 max-w-xs" data-id="element-126">
              Curated wines and custom label services that make every experience
              personal, accessible, and memorable.
            </p>
            <div className="flex space-x-4" data-id="element-127">
              <a href="#" className="text-cream-100/50 hover:text-gold transition-colors" data-id="element-128">
                <span className="sr-only" data-id="element-129">Instagram</span>
                <Instagram className="h-5 w-5" data-id="element-130" />
              </a>
              <a href="#" className="text-cream-100/50 hover:text-gold transition-colors" data-id="element-131">
                <span className="sr-only" data-id="element-132">Facebook</span>
                <Facebook className="h-5 w-5" data-id="element-133" />
              </a>
              <a href="#" className="text-cream-100/50 hover:text-gold transition-colors" data-id="element-134">
                <span className="sr-only" data-id="element-135">Twitter</span>
                <Twitter className="h-5 w-5" data-id="element-136" />
              </a>
            </div>
          </div>

          {/* Column 2: Explore */}
          <div data-id="element-137">
            <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-6" data-id="element-138">
              Explore
            </h3>
            <ul className="space-y-4" data-id="element-139">
              <li data-id="element-140">
                <a href="#collection" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-141">
                  Our Wines
                </a>
              </li>
              <li data-id="element-142">
                <a href="/design#gallery" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-143">
                  Custom Labels
                </a>
              </li>
              <li data-id="element-144">
                <a href="/design" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-145">
                  How It Works
                </a>
              </li>
              <li data-id="element-146">
                <a href="#pricing" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-147">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Company */}
          <div data-id="element-148">
            <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-6" data-id="element-149">
              Company
            </h3>
            <ul className="space-y-4" data-id="element-150">
              <li data-id="element-151">
                <a href="#about" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-152">
                  About Us
                </a>
              </li>
              <li data-id="element-153">
                <a href="/vineyard" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-154">
                  Vineyards
                </a>
              </li>
              <li data-id="element-155">
                <a href="#" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-156">
                  Partners
                </a>
              </li>
              <li data-id="element-157">
                <a href="/blog" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-158">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Support */}
          <div data-id="element-159">
            <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-6" data-id="element-160">
              Support
            </h3>
            <ul className="space-y-4" data-id="element-161">
              <li data-id="element-162">
                <a href="#" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-163">
                  Contact
                </a>
              </li>
              <li data-id="element-164">
                <a href="/faq" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-165">
                  FAQ
                </a>
              </li>
              <li data-id="element-166">
                <a href="#" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-167">
                  Shipping
                </a>
              </li>
              <li data-id="element-168">
                <a href="#" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-169">
                  Terms
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-170">
          <p className="text-cream-100/50 text-xs" data-id="element-171">
            &copy; {new Date().getFullYear()} Wine & Design. All rights
            reserved.
          </p>
          <div className="flex space-x-6" data-id="element-172">
            <a href="#" className="text-cream-100/50 hover:text-white text-xs transition-colors" data-id="element-173">
              Privacy Policy
            </a>
            <a href="#" className="text-cream-100/50 hover:text-white text-xs transition-colors" data-id="element-174">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}